<template>
  <div class="pt-2 pb-10">
    <div class="rounded-xl shadow-nw px-4 py-3 mt-5" v-for="(order, index) in order_history" :key="index">
      <div class="text-sm font-extrabold inline-block">
        Order#: <span class="uppercase">{{ firstFour(order.doc_id) }}</span>
      </div>
      <div class="text-sm font-extrabold inline-block float-right pt-px">&#8358;{{ order.payment_details.total }}</div>
      <div class="text-xs text-nw-ash">
        <date-created :created_at="order.pick_up.time_pick_up"></date-created>
      </div>
      <div v-if="clickedIndex == index">
        <div class="border-t border-gray-200 my-3"></div>
        <div class="flex">
          <div class="mt-3">
            <route-icon></route-icon>
          </div>
          <div class="px-4">
            <div class="text-xs text-nw-ash">Pick-up Location</div>
            <div class="text-xs font-extrabold pt-1">
              {{ order.pick_up.location }}
            </div>
            <div class="border-t border-gray-200 -mr-6 my-3"></div>
            <div class="text-xs text-nw-ash">Drop-off Location</div>
            <div class="text-xs font-extrabold pt-1">
              {{ order.delivering.location }}
            </div>
          </div>
        </div>
      </div>
      <div class="border-t border-gray-200 my-3 -mx-4"></div>
      <div class="text-xs font-semibold w-full" @click="expend(index)">
        <span class="text-purple-600" v-if="order.attached.attached_at == undefined">Processing</span>
        <span
          class="text-nw-light-green"
          v-if="order.attached.picked_at == undefined && order.attached.attached_at != undefined"
          >Heading to pick-up</span
        >
        <span
          class="text-green-600"
          v-if="order.attached.picked_at != undefined && order.attached.delivered_at == undefined"
          >Heading to delivery</span
        >
        <span class="text-green-900" v-if="order.attached.delivered_at != undefined">Delivered</span>
        <span class="float-right">
          <arrow-down-icon v-if="clickedIndex != index"></arrow-down-icon>
          <arrow-up-icon v-if="clickedIndex == index"></arrow-up-icon>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DateCreated from '../DateCreated.vue'
import ArrowDownIcon from '../icons/ArrowDownIcon.vue'
import ArrowUpIcon from '../icons/ArrowUpIcon.vue'
import RouteIcon from '../icons/RouteIcon.vue'
export default {
  components: { ArrowDownIcon, ArrowUpIcon, RouteIcon, DateCreated },
  data() {
    return {
      clickedIndex: null,
      show_map: false
    }
  },
  computed: {
    ...mapState('history', ['order_history'])
  },
  methods: {
    firstFour(string) {
      return string.substring(0, 6)
    },
    expend(index) {
      if (this.clickedIndex == index) {
        this.clickedIndex = null
      } else {
        this.clickedIndex = index
      }
    },
    openMap(val) {
      this.show_map = val
    }
  },
  mounted() {}
}
</script>
